<!-- Features Section -->
<section class="bg-white dark:bg-slate-900 ">
    <div class="max-w-7xl mx-auto p-0  md:px-4">
        <div class="container mx-auto px-6 bg-white dark:bg-slate-900">
            @if(view.site?.id !== 79) {
                <div class="py-8 flex flex-col items-center justify-center text-center">
                    <h4 class="text-base text-primry-600 font-semibold tracking-wide uppercase">{{view.heading}}</h4>
                    <p class="mt-2 text-5xl lg:text-7xl font-light font-primary tracking-tight text-gray-900 dark:text-gray-200">How <span class="font-bold">{{ view.site?.id === 72 ? 'Business travel' : view.title }}</span> Changes the Game</p>
                    @if(view.site?.id != 79) {
                        <img class="w-100" src="assets/xltravel/swoosh-01.svg" alt="xl underline">
                    }
                </div>
            }
            @if(view.site?.id === 79) {
            <div class="flex flex-col justify-center w-full">
                <div class="flex justify-center">
                    <img src="/assets/images/sections/ST BUSINESS TRAVEL.png" class="w-100" alt="business packages header image">
                </div>
                <div class="flex justify-center">
                    <p class="max-w-4xl pt-10 px-4 text-center" [innerHTML]="view.page?.content.rawContentShort"></p>
                    <!-- <p class="px-4 text-gray-500" >Our customizable corporate travel programs align seamlessly with your company's requirements, ensuring duty of care and effective risk management through automated travel advisories and alerts. We focus on delivering an exceptional client experience, guiding you from the initial requisition to post-travel support. Our fast-acting systems identify out-of-policy behavior swiftly, while our partnership with Egencia enhances global travel management. With industry-leading technology, we maximize returns by serving our customers' needs effectively. Monitoring travel performance is made easy with email alerts, scheduled reporting, and dynamic insights. Experience unmatched customer care from dedicated consultants who prioritize your travel success in a competitive marketplace. Enjoy exceptional savings on hotels, cars, and airfare.</p> -->
                </div>
            </div>
            }
                <div class="flex flex-wrap py-10">
                    @for (feature of view.features; track feature; let idx = $index) {
                    <div class="w-full sm:w-1/2 md:w-1/3 p-2 md:p-4 lg:p-8" [class.sm:border-r]="(idx % 2 < 1) && view.isScreenSmall"
                        [class.sm:border-b]="(idx < view.features.length - 2) && view.isScreenSmall" [class.md:border-r]="(idx % 3 <= 1)"
                        [class.md:border-b]="(idx < view.features.length - 3)">
                        <div class="flex items-center mb-2 md:mb-6 lg:mb-6">
                            <mat-icon
                                class="icon-size-8 bg-accent-500 text-white rounded-full w-20 h-20 md:w-20 md:h-20 border-4 border-white transition-opacity ease-in duration-700 opacity-100"
                                [matTooltip]="''"
                                [svgIcon]="feature.icon">
                            </mat-icon>
                            <!-- <div class="ml-4 text-xl" [innerHTML]="feature.title"></div> -->
                            <h2 class="ml-4 font-semibold text-xl text-primary-500 tracking-wide uppercase">{{ view.site?.id === 72 && (feature.title === 'Corporate Flights' || feature.title === 'CORPORATE FLIGHTS') ? 'Business Flights' : feature.title }}</h2>
                        </div>
                        <p class="leading-loose text-gray-500 dark:text-gray-200" [innerHTML]="feature.text"></p>
                    </div>
                    }
                </div>
        </div>
    </div>
    @if (view.options.showSlider) {
    <div class="bg-gray-100 dark:bg-slate-700">
        <div class="py-6 w-[90%] m-auto">
            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
                (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
                (beforeChange)="beforeChange($event)">
                <fuse-card ngxSlickItem class="relative m-2 isolate flex flex-col justify-end px-4 pb-4 pt-4  t-20 h-48">
                    <img class="w-full h-full"
                    src="assets/images/logo/xl-logo-2.png"
                    alt="leisure travel" />
                </fuse-card>
                <fuse-card ngxSlickItem class="relative m-2 isolate flex flex-col justify-end  px-4 pb-4 pt-4  t-24 h-48">
                    <img class="w-full h-full"
                    src="assets/images/logo/xlGo.png"
                    alt="leisure travel" />
                </fuse-card>
                <fuse-card ngxSlickItem class="relative m-2 isolate flex flex-col justify-end  px-4 pb-4 pt-4  t-24 h-48">
                    <img class="w-full h-full"
                    src="assets/images/logo/xl-holidays-logo.png"
                    alt="leisure travel" />
                </fuse-card>
                <fuse-card ngxSlickItem class="relative m-2 isolate flex flex-col justify-end  px-4 pb-4 pt-4  t-24 h-48">
                    <img class="w-full h-full"
                    src="assets/images/logo/xlTravel.png"
                    alt="leisure travel" />
                
                </fuse-card>
               
            </ngx-slick-carousel>
        </div>
    </div>
    }
</section>
  